import React from 'react';
import { getCompanyLogo, COMPANY_LOGOS } from '../../data/companyLogos';

export default function CompanyLogo({ company, size = 36, className = '' }) {
  if (!company) return null;

  const s = size;

  // Custom uploaded logo
  if (company.customLogo) {
    return (
      <img
        src={company.customLogo}
        alt={company.name}
        className={`rounded-lg object-contain bg-white ${className}`}
        style={{ width: s, height: s }}
        data-testid="company-logo"
      />
    );
  }

  // Preset retail logo (image). Old saves may reference a removed id → fallback.
  const preset = getCompanyLogo(company.logo) || COMPANY_LOGOS[0];
  if (preset) {
    return (
      <img
        src={preset.src}
        alt={company.name || preset.nom}
        className={`rounded-lg object-contain bg-white flex-shrink-0 ${className}`}
        style={{ width: s, height: s }}
        data-testid="company-logo"
      />
    );
  }

  // Ultimate fallback: initial letter badge.
  return (
    <span
      className={`rounded-lg bg-accent text-white font-black flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ width: s, height: s, fontSize: s * 0.5 }}
      data-testid="company-logo"
    >
      {(company.name || '?').charAt(0).toUpperCase()}
    </span>
  );
}
